var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cms-form',{attrs:{"post":_vm.currentCms,"loading":_vm.loading},on:{"submit":_vm.updatePost}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }